import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';

export const useWebBasic = (
  options: { wines?: string; market?: string } = {}
) => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/web/premium/overview',
    {
      params: {
        query: {
          wines: options.wines || undefined,
          market: options.market || undefined
        }
      }
    }
  );

  return {
    isLoading,
    webBasicData: data || {
      kpis: [],
      feed: [],
      prices: [],
      store_references: [],
      dn_history: [],
      filters: { client_wines: [], markets: [] }
    },
    refetch
  };
};

export const useWebDetailed = (
  options: { vintage?: string; wines?: string; market?: string } = {}
) => {
  const { isLoading, data, refetch } = useTypedQuery(
    'get',
    '/web/premium/details',
    {
      params: {
        query: {
          vintage: options.vintage || undefined,
          wines: options.wines || undefined,
          market: options.market || undefined
        }
      }
    }
  );

  return {
    isLoading,
    webDetailedData: data || {
      kpis: [],
      feed: [],
      prices: [],
      references: [],
      price_history: [],
      filters: { client_wines: [], markets: [] }
    },
    refetch
  };
};
